<template>
  <div>
    <a-modal
      v-model="visible"
      title="培训结果"
      width="700px"
      :keyboard="false"
      :maskClosable="false"
      @cancel="cancel"
      centered
      :getContainer="getContainer"
    >
      <div>
        <div class="header">
          <div class="name1">
            <a-space :size="40">
              <div>
                合格：{{
                  controlRot.filter((v) => v.score >= parseFloat(bad)).length
                }}人
              </div>
              <div>
                不合格：{{
                  controlRot.filter((v) => v.score < parseFloat(bad)).length
                }}人
              </div>
            </a-space>
          </div>
          <div class="name2">
            <a-space :size="30">
              <div>
                培训时间：{{ moment(studyTime).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div>
                考试时间：{{ moment(examTime).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
            </a-space>
          </div>
        </div>
        <a-table
          :columns="columns"
          :data-source="controlRot"
          :pagination="false"
          :scroll="{ y: 550 }"
        >
          <template slot="ispass" slot-scope="text, record">
            <a
              :style="{
                color:
                  parseFloat(record.score) >= parseFloat(bad)
                    ? '#4DCC66'
                    : '#EA1313',
              }"
              >{{
                parseFloat(record.score) >= parseFloat(bad) ? "合格" : "不合格"
              }}</a
            >
          </template>
          <template slot="operation" slot-scope="text, record">
            <a
              href="javascript:;"
              @click="sign(record)"
              :style="{ color: record.sign && record.finger ? '#000' : '' }"
              >{{ record.sign && record.finger ? "查看签字" : "签字" }}</a
            >
          </template>
        </a-table>
      </div>
      <div slot="footer">
        <a-button @click="exportData">导出</a-button>
        <a-button type="primary" @click="handleOk" :loading="overloading"
          >完成</a-button
        >
      </div>
    </a-modal>
    <ShowFile ref="showFile" @ok="okFile"></ShowFile>
    <SignPop
      ref="signPop"
      aloneBackData
      @aloneBackDataCallback="aloneBackDataCallback"
    ></SignPop>
  </div>
</template>

<script>
import moment from "moment";
import { saveExcel } from "@/utils/os";
import ShowFile from "./showFile";
import SignPop from "../../files/components/signPop";
export default {
  components: {
    SignPop,
    ShowFile,
  },
  props: {
    //培训方案名称
    name: {
      type: String,
      default: "",
    },
    //培训时间
    studyTime: {
      type: Number,
      default: new Date().getTime(),
    },
    //考试时间
    examTime: {
      type: Number,
      default: new Date().getTime(),
    },
    //考试结果
    controlRot: {
      type: Array,
      default() {
        return [];
      },
    },
    //及格线
    bad: {
      type: Number,
      default: 0,
    },
    //最后数据发送loading
    overloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      columns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "答题器",
          dataIndex: "iKeyID",
          key: "iKeyID",
        },
        {
          title: "考试得分",
          dataIndex: "score",
          key: "score",
        },
        {
          title: "是否合格",
          dataIndex: "ispass",
          scopedSlots: { customRender: "ispass" },
        },
        {
          title: "编辑",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
    };
  },
  methods: {
    moment,

    //导出
    exportData() {
      const time = moment(new Date()).format("YYYY-MM-DD");
      const data = this.controlRot.map((v) => {
        return {
          培训方案: this.name,
          姓名: v.name,
          身份证号: v.id_no,
          考试得分: v.score,
          是否合格:
            parseFloat(v.score) >= parseFloat(this.bad) ? "合格" : "不合格",
          考试时间: time,
        };
      });
      saveExcel(data, this.name + "考试结果" + time);
    },
    //合同弹窗确认签字
    okFile(e) {
      this.sign(e);
      this.$refs.signPop.init(e);
    },
    //签字
    sign(record) {
      if (record.sign && record.finger) {
        return this.$refs.signPop.init({ id: record.iKeyID, ...record });
      }
      this.$refs.showFile.init({ id: record.iKeyID, ...record });
    },
    //签字和指纹返回
    aloneBackDataCallback(e) {
      this.$emit("signCallback", e);
    },
    cancel() {},
    //完成
    handleOk() {
      const nook = this.controlRot.filter((v) => !v.sign && !v.finger);
      if (nook.length > 0) {
        this.$confirm({
          centered: true,
          title: `${nook.length}人尚未签字，是否继续操作？`,
          content: "未签字人员成绩会录入系统中，但只会缺少签字图像",
          cancelText: "返回签字",
          okText: "确认提交",
          getContainer: ()=> document.getElementById("bodyContnet"),
          onOk: () => {
            this.sendOver();
          },
          onCancel: () => {},
        });
      } else {
        this.sendOver();
      }
    },
    //发送结果数据
    sendOver() {
      this.$emit("sendOver");
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  background: #edf5ff;
  padding: 20px 18px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.name1 {
  font-size: 20px;
  color: #011733;
}
.name2 {
  font-size: 14px;
  font-weight: 400;
  color: #9ba2ab;
  margin-top: 10px;
}
</style>